import { RefObject, useCallback, useState } from 'react';
import { Selectable } from 'components/atoms/grid';

export const useSelections = (selectionsRef: RefObject<Selectable>) => {
  const [selected, setSelected] = useState<string[]>([]);
  const count = selected.length;
  const [isSelectedAll, setSelectAll] = useState(false);
  const reset = useCallback(() => {
    selectionsRef.current?.resetSelections?.();
    setSelectAll(false);
  }, [selectionsRef]);
  const selectAll = useCallback(() => {
    selectionsRef.current?.selectAll?.();
    setSelectAll(true);
  }, [selectionsRef]);

  return {
    selected,
    setSelected,
    count,
    reset,
    selectAll,
    isSelectedAll,
  };
};
